import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { userApi } from "@/http/apiList"
import { useAuth } from '@/context/AuthContext'
import { Link } from 'react-router-dom'
export default function InnerHeader() {
    const { refreshAuthStatus } = useAuth()
    const handleLogout = async () => {
        await userApi.logout();
        await refreshAuthStatus();
        window.location.href = "/inner-page";
    }

    return (
        <header className="border-b border-[#8D9EB9]">
            <div className="container max-w-7xl mx-auto px-4 flex items-center justify-between h-[60px]">
                <Link to={'/'} className="w-[109px] h-[34px] bg-[url('@/assets/images/idata-logo.gif')] bg-cover cursor-pointer"></Link>
                <button className="flex items-center space-x-2 text-gray-600 hover:text-blue-600">
                <Popover>
                    <PopoverTrigger asChild>
                        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <title>登录备份 2@1x</title>
                            <g id="页面-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <g id="详情页" transform="translate(-1569.000000, -20.000000)">
                                    <g id="编组-4" transform="translate(0.000000, -0.000000)">
                                        <g id="编组" transform="translate(1567.000000, 18.000000)">
                                            <rect id="矩形" fill="#D8D8D8" opacity="0" x="0" y="0" width="24" height="24"></rect>
                                            <g id="编组-6" transform="translate(2.000000, 2.000000)" stroke="#161616">
                                                <g id="编组" transform="translate(4.333333, 3.666667)">
                                                    <circle id="椭圆形" cx="5.66666667" cy="2.66666667" r="2.16666667"></circle>
                                                    <path d="M8.5,6.83333333 C9.14433221,6.83333333 9.72766554,7.09450056 10.1499158,7.51675084 C10.5721661,7.93900113 10.8333333,8.52233446 10.8333333,9.16666667 L10.8333333,9.16666667 L10.8333333,11.6666667 L0.666666667,11.8333333 L0.5,9.16666667 C0.5,8.52233446 0.761167229,7.93900113 1.18341751,7.51675084 C1.60566779,7.09450056 2.18900113,6.83333333 2.83333333,6.83333333 L2.83333333,6.83333333 Z" id="矩形"></path>
                                                </g>
                                                <circle id="椭圆形" cx="10" cy="10" r="9.5"></circle>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </PopoverTrigger>
                    <PopoverContent className="w-auto bg-white w-[145px] h-[40px] p-0 flex justify-center items-center cursor-pointer hover:bg-[#E8E8EB]">
                        <span className="text-[16px] text-[#191919]" onClick={handleLogout}>Logout</span>
                    </PopoverContent>
                </Popover>
                </button>
            </div>
        </header>
    )
}